import * as React from 'react';

import type { ICianMFUIElement } from '@cian/mf-registry/browser';
import type { IMicrofrontendManifest } from '@cian/mf-registry/shared';

export enum ESource {
  Favorites = 'favorites',
}

export enum ESubscriptionLimitType {
  PhoneNumber = 'phoneNumber',
  Chat = 'chat',
}

export type TCheckContactsAccessParams = {
  offerId: number;
  limitType: ESubscriptionLimitType;
};

export type TAccessCheckResult = {
  isConfirmed: boolean;
  trackingStatus: string | null;
};

export type TEarlyAccessPaywallParams = {
  isAuthenticated?: boolean;
  source: string;
};

export type TContext = IContextSucceed | IContextLoading | IContextFailed;

interface IContextSucceed extends IBaseContext {
  status: EStatus.Succeed;
  manifest: IMicrofrontendManifest;
}

interface IContextLoading extends IBaseContext {
  status: EStatus.Loading;
}

interface IContextFailed extends IBaseContext {
  status: EStatus.Failed;
}

interface IBaseContext {
  status: EStatus;
  microfrontendRef: React.RefObject<ICianMFUIElement>;
  params: TEarlyAccessPaywallParams;
  open: boolean;
  onClose(): void;
  checkContactsAccess(params: TCheckContactsAccessParams): Promise<TAccessCheckResult>;
  lastUsedOfferId: number | null;
}

export enum EStatus {
  Succeed = 'succeed',
  Loading = 'loading',
  Failed = 'failed',
}
